import { useIntl } from 'react-intl'

/**
 * Returns a lookup of CruiseDurationOptions.name → localised label.
 * Shared between CruiseWhenSelectHowLong and CruiseSearchFiltersMobile.
 *
 * `intl.formatMessage` already caches by descriptor id, so no extra
 * memoisation is needed here.
 */
function useCruiseDurationLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    'Any duration': intl.formatMessage({
      id: '1-V-v57Py1xxPhhXcw9p',
      defaultMessage: 'Any duration',
      description: 'Filter chip label for selecting any cruise duration',
    }),
    '1 - 4 Nights': intl.formatMessage({
      id: 'bnvI6y_PwUAUoK_o10dS',
      defaultMessage: '1 - 4 Nights',
      description: 'Filter chip label for short cruise stays of 1 to 4 nights',
    }),
    '5 - 8 Nights': intl.formatMessage({
      id: 'lINPu39KGctdxpsb_FA7',
      defaultMessage: '5 - 8 Nights',
      description: 'Filter chip label for medium cruise stays of 5 to 8 nights',
    }),
    '9 - 14 Nights': intl.formatMessage({
      id: '7OoBxD0PFpxTPb6TVsk8',
      defaultMessage: '9 - 14 Nights',
      description: 'Filter chip label for long cruise stays of 9 to 14 nights',
    }),
    '15+ Nights': intl.formatMessage({
      id: '27gPyw9T_FN1Hbavaylg',
      defaultMessage: '15+ Nights',
      description: 'Filter chip label for very long cruise stays of 15 or more nights',
    }),
  }
}

export default useCruiseDurationLabels
